export const getMenuItems = (isMobile, isCriticWidth) => [
  {
    title: 'whatWeDo',
    link: '/what-we-do',
  },
  {
    title: 'howWeWork',
    link: '/how-we-work',
  },
  {
    title: 'whoWeAre',
    link: '/who-we-are',
  },
  {
    title: isCriticWidth ? 'insights' : 'medignition insights',
    link: '/insights',
  },
  ...(isMobile ? [] : [{
    title: 'contact',
    link: '/contacts',
  }]),
];

export const infoItems = [
  {
    title: 'imprint',
    link: '/imprint',
  },
  {
    title: 'privacy',
    link: '/privacy',
  },
  {
    title: 'terms',
    link: '/terms',
  },
];
